import { makeStyles } from '@mui/styles';

export default makeStyles( theme => ({
    gridContainer: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    itemCard: {
      width: '100%',
    },
    root: {
      marginBottom: 20,
    },
    informationContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom: 10,
      alignItems: 'center',
    },
    title: {
      fontWeight: 'bold',
      fontSize: 16,
      lineHeight: '27px',
      textAlign: 'right',
      marginRight: 10,
    },
    description: {
      fontSize: 16,
      textAlign: 'center',
      padding: '5px 0px 5px 0',
      marginLeft: 27,
      border: '2px solid #e0e0e0',
      borderRadius: '16px',
      width: '75%',
      '@media (max-width: 960px)': {
        width: '90%',
      }
    },
    icon: {
      fontSize: '28px',
      color: 'rgba(0, 0, 0, 0.54)',
    },
    constanciesPDF: {
      display: 'flex',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
      marginBottom: 10,
      marginTop: 10,
      width: '100%',
    },
    leftIcon: {
      marginRight: theme.spacing(1),
    },
    iconSmall: {
        fontSize: 20,
    },
    button:{
      "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)",
      "border":"0px",
      "borderRadius":"3",
      "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)",
      "color":"white",
      textAlign: 'center',
    },
    buttonCancel:{
      "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)",
      "border":"0px",
      "borderRadius":"3",
      "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)",
      "color":"white",
      textAlign: 'center',
    },
    gridButton: {
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
    },
    titleDetalle: {
      textAlign: 'center',
      fontSize: '27px',
      margin: "5px 0px",
      fontWeight: 800
    },
    titleAlerta: {
      marginTop: 100,
      fontWeight: 'bold',
      fontSize: 27,
      lineHeight: '27px',
      textAlign: 'center',
      marginRight: 10,
    },
}));
